import PassportApp from './PassportApp'

export default PassportApp
